import React from "react";
import LayoutTwo from "../../layouts/LayoutTwo";
import { Breadcrumb } from "react-bootstrap";
import { useParams } from "react-router-dom";
import LayoutOne from "../../layouts/LayoutOne";
import BarcodeScanComponent from "./ScanBarCode";
const Custom101: React.FC = ({ pageId }) => {
  const { pageSlug } = useParams();
  //const bannerImage = require("../../assets/images/steker2.jpg");
  const bannerImage =
    "https://dukany.io/cdn-cgi/image/width=1800,height=auto,fit=cover,format=webp/https://meemapp-order.s3.ap-southeast-1.amazonaws.com/apps/myncdapp/dukany-theme-custom-pages/device_free_install_check/sticker-600-600.jpg";
  const bannerImageDesktop =
    "https://dukany.io/cdn-cgi/image/width=1800,height=400,fit=cover,format=webp/https://meemapp-order.s3.ap-southeast-1.amazonaws.com/apps/myncdapp/dukany-theme-custom-pages/device_free_install_check/sticker-1800-480.jpg";
  return (
    <div>
      <LayoutOne>
        <div className="d-flex flex-column">
          <picture className="">
            <source media="(max-width : 700px)" srcSet={bannerImage} />

            <img
              alt="free-install0img"
              src={bannerImageDesktop}
              alt="Banner"
              style={{
                width: "100%",
                marginBottom: 20,
                height: "300px",
              }}
            />
          </picture>

          <BarcodeScanComponent />
        </div>
      </LayoutOne>
    </div>
  );
};

export default Custom101;
